module.exports = __webpack_public_path__ + "static/media/looking_to_grow.ddf94e87.png";